import React, {
  RefObject,
  useMemo,
} from 'react';
import AutoComplete from 'core/components/AutoComplete';
import {
  InputProps,
} from '@mui/material/Input';
import {
  ChevronDownIcon,
} from 'core/icons';
import {
  useGetMediaTypesList,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/hooks';
import {
  MultimediaTypeWithCategory,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/Multimedia/FileUploadDialog';

type Props = {
  onChange: (...event: string[]) => void;
  value?: string | null;
  className?: string;
  inputRef?: RefObject<HTMLInputElement>;
  InputProps?: Partial<InputProps>;
};

export function getMediaCategory(value: string, categoryList: MultimediaTypeWithCategory[]) {
  return categoryList.find(
    (option) => (option.label === value?.trim() || option.value === value?.trim()),
  ) ?? null;
}

export default function FileTypeSelect({
  onChange,
  value,
  className,
  inputRef,
  InputProps,
  ...props
}: Props) {
  const mediaTypes = useGetMediaTypesList();

  const selectedCategory = useMemo<MultimediaTypeWithCategory | null>(
    () => getMediaCategory(value ?? '', mediaTypes ?? []),
    [value],
  );

  const onMediaCategoryChange = (
    val: MultimediaTypeWithCategory | MultimediaTypeWithCategory[],
  ) => {
    const value = (val as MultimediaTypeWithCategory)?.value ?? '';
    onChange(value);
  };

  return (
    <AutoComplete<MultimediaTypeWithCategory>
      {...props}
      inputRef={inputRef}
      onChange={onMediaCategoryChange}
      value={selectedCategory}
      className={className}
      placeholder="Media Category"
      id="media-category"
      options={mediaTypes}
      getLabel={(option) => option?.label ?? ''}
      groupBy={(option) => option.category}
      openOnFocus
      renderGroup={({
        key,
        group,
        children,
      }) => (
        <div key={key}>
          <div className="p-2 text-primary-700 font-semibold text-xs">
            {group}
          </div>
          <ul className="px-1">{children}</ul>
        </div>
      )}
      dropdownClassName="!p-0"
      classes={{
        inputRoot: '!pr-2 !py-2',
        input: '!mr-4 !truncate',
      }}
      InputProps={InputProps}
      popupIcon={<ChevronDownIcon className="text-gray-400 -mt-1" />}
    />
  );
}
